export enum EICMSeverity {
  Informational = 'Informational',
  Sev4 = 'Sev4',
  Sev3 = 'Sev3',
  Sev2 = 'Sev2', // NOTE: Do not use this unless specifically requested.
}

export enum EICMType {
  General = 'General',
  Critical = 'Critical',
  API = 'API',
  Kusto = 'Kusto',
  Dependencies = 'Dependencies',
}
